/**
 * Article slug helper shared by runtime code (`blogUtils`), the build-time
 * fetcher (`blogArticleList`) and `react-router.config.ts`. Kept dependency- and
 * alias-free (no `@/` imports, no browser/Jotai code) so it can be imported via
 * a relative path from plain Node during the build, before Vite aliases exist.
 *
 * This MUST stay the single source of truth for slugging: prerender paths,
 * sitemap <loc> entries and runtime article URLs all derive from it, so any
 * divergence would produce broken links and SEO drift.
 */

const FINNISH_CHAR_MAP: Record<string, string> = { å: "a", ä: "a", ö: "o" };

export const getArticleUrl = (title: string): string =>
  title
    .toLowerCase()
    .replaceAll(/[åäö]/g, (ch) => FINNISH_CHAR_MAP[ch] ?? ch)
    .replaceAll(" ", "-")
    .replaceAll(/[^a-z0-9-]/g, "");
